// Persists the page a user wanted to reach when they were bounced to /login.
// Uses sessionStorage (survives the Google sign-in popup; cleared on tab close).
//
// Flow:
//   1. ProtectedRoute / pages call setReturnTo(path) before redirecting to /login.
//   2. After Google sign-in completes, Login.jsx reads + clears it and navigates
//      the user to where they originally wanted to be.

const KEY = "zc_return_to";
const TS_KEY = "zc_return_to_ts";
const GATE_KEY = "zc_return_to_gate";
const TTL_MS = 30 * 60 * 1000;          // 30 minutes
const SAFE_PREFIXES = ["/", "/browse", "/parking", "/vehicles/", "/parking/", "/book/", "/profile", "/dashboard"];

function isSafePath(p) {
  if (!p || typeof p !== "string") return false;
  if (!p.startsWith("/")) return false;
  if (p === "/login" || p.startsWith("/login")) return false;
  return SAFE_PREFIXES.some((pref) => p === pref || p.startsWith(pref));
}

export function clearReturnTo() {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(TS_KEY);
    sessionStorage.removeItem(GATE_KEY);
  } catch (e) { /* ignore */ }
}

export function setReturnTo(pathWithQuery) {
  try {
    if (!isSafePath(pathWithQuery)) return;
    sessionStorage.setItem(KEY, pathWithQuery);
    sessionStorage.setItem(TS_KEY, String(Date.now()));
    sessionStorage.setItem(GATE_KEY, "1");
  } catch (e) { /* private mode etc. — ignore */ }
}

export function consumeReturnTo() {
  try {
    const path = sessionStorage.getItem(KEY);
    const tsRaw = sessionStorage.getItem(TS_KEY);
    const gated = sessionStorage.getItem(GATE_KEY) === "1";
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(TS_KEY);
    sessionStorage.removeItem(GATE_KEY);
    if (!gated || !path || !isSafePath(path)) return null;
    const ts = Number(tsRaw);
    if (!ts || Date.now() - ts > TTL_MS) return null;
    return path;
  } catch (e) { return null; }
}

export function peekReturnTo() {
  try {
    const path = sessionStorage.getItem(KEY);
    const gated = sessionStorage.getItem(GATE_KEY) === "1";
    if (!gated || !path || !isSafePath(path)) return null;
    const tsRaw = sessionStorage.getItem(TS_KEY);
    const ts = Number(tsRaw);
    if (!ts || Date.now() - ts > TTL_MS) return null;
    return path;
  } catch (e) { return null; }
}
